<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModalInserirItem()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Item
            </span>
        </b-button>
        <b-modal id="modalInserirSubItem" v-model="mostrarModalInserirItem" @show="preencherForm()">
            <div slot="modal-title">
                Item do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="contratoElaboracao()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo Produto</label>
                        <model-list-select
                            :list="tiposProduto"
                            option-text="nomeFantasia"
                            option-value="codigo"
                            v-model="tipoProduto.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="contratoElaboracao()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo Faturamento</label>
                        <model-list-select
                            :list="tiposFaturamento"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="tipoFaturamento.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="contratoElaboracao()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Natureza</label>
                        <model-list-select
                            :list="naturezas"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="natureza.codigo"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A descrição é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea v-model="descricaoResumida" :rows="4" :maxlength="200"></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input type="number" v-model="quantidade"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="contrato.vinculoRM">
                <b-col sm="12">
                    <b-form-group>
                        <label>Item de Contrato RM</label>
                        <b-form-select
                            :options="itensContratoRM"
                            v-model="seqRm"
                            text-field="descricao"
                            value-field="seqRm"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A justificativa {{textoInfoJustificativa}} é obrigatória</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModalInserirItem()">Cancelar</b-button>
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarItem()"
                    class="ml-1"
                >Salvar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import ContratosRMServicos from './../../rm/ContratosRMServicos'
import { ModelListSelect } from 'vue-search-select'
import { situacaoContrato } from '../SituacaoContrato'
import ContratoRmServicos from '../../rm/ContratosRMServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        ModelListSelect
    },

    data() {
        return {
            mostrarModalInserirItem: false,
            obterContratoAtualizado: false,
            operacao: 'INSERÇÃO',
            erros: [],
            descricao: '',
            descricaoResumida: '',
            valor: 0,
            quantidade: 0,
            seqRm: 0,
            itensContratoRM: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            tiposProduto: [],
            tipoProduto: {
                codigo: '',
                nomeFantasia: ''
            },
            tiposFaturamento: [],
            tipoFaturamento: {
                codigo: '',
                descricao: ''
            },
            naturezas: [],
            natureza: {
                codigo: '',
                descricao: ''
            },
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModalInserirItem() {
            this.mostrarModalInserirItem = true
        },

        fecharModalInserirItem() {
            this.mostrarModalInserirItem = false
            this.resetInserirItem()
            if (this.obterContratoAtualizado) {
                this.$emit('obterItensAtualizados')
            }
        },

        resetInserirItem() {
            this.justificativaApostilamento = ''
            this.descricao = ''
            this.descricaoResumida = ''
            ;(this.valor = 0), (this.quantidade = 0), (this.seqRm = 0)
            this.erros = []
            this.tipoProduto = {}
            this.tipoFaturamento = {}
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterItensContratoRM()
        },

        confirmarSalvarItem() {
            this.$swal({
                title: 'Item do Contrato',
                html: `Confirma a inserção do item no contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvarItem()
                }
            })
        },

        buscaElemento(colecao, elementoCod) {
            return colecao.find((x) => x.codigo == elementoCod)
        },

        salvarItem() {
            this.$store.dispatch('addRequest')
            let itemNovoDto = {
                idContrato: this.$route.params.contratoId,
                itemContratoId: 0,
                itemReferenciaId: 0,
                descricao: this.descricao,
                descricaoResumida: this.descricaoResumida,
                valor: this.valor,
                quantidade: this.quantidade,
                seqRm: this.seqRm,
                justificativaApostilamento: this.justificativaApostilamento,
                tipoProduto: this.buscaElemento(
                    this.tiposProduto,
                    this.tipoProduto.codigo
                ),
                tipoFaturamento: this.buscaElemento(
                    this.tiposFaturamento,
                    this.tipoFaturamento.codigo
                ),
                natureza: this.buscaElemento(
                    this.naturezas,
                    this.natureza.codigo
                ),
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarItemContrato(itemNovoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro inserido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterContratoAtualizado = true
                            this.fecharModalInserirItem()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        seqRmOk() {
            if (this.contrato.vinculoRM) {
                if (this.seqRm > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        obterItensContratoRM() {
            this.$store.dispatch('addRequest')
            ContratosRMServicos.obterItenPorContrato(this.contrato.idRM).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.itensContratoRM = response.data
                            this.itensContratoRM = this.itensContratoRM.map(
                                (item) => {
                                    return {
                                        seqRm: item.seqRm,
                                        descricao: `NSEQ: ${item.seqRm} - ${item.descricao} - Valor: ${item.valor}`
                                    }
                                }
                            )
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        verificaTipoProduto() {
            if (this.contratoElaboracao()) {
                if (this.tipoProduto.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        verificaTipoFaturamento() {
            if (this.contratoElaboracao()) {
                if (this.tipoFaturamento.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        verificaNatureza() {
            if (this.contratoElaboracao()) {
                if (this.natureza.codigo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },

        obterTiposProdutoRM() {
            ContratoRmServicos.obterTiposProdutoRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposProduto = response.data
                    }
                }
            })
        },

        obterTiposFaturamentoRM() {
            ContratoRmServicos.obterTiposFaturamentoRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tiposFaturamento = response.data
                    }
                }
            })
        },

        obterNaturezasRM() {
            ContratoRmServicos.obterNaturezasRM().then((response) => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    }
                }
            })
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-05')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-05')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
        this.obterTiposProdutoRM()
        this.obterTiposFaturamentoRM()
        this.obterNaturezasRM()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        }
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        },
        seqRm: {
            seqRmOk() {
                return this.seqRmOk()
            }
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        tipoProduto: {
            verificaTipoProduto() {
                return this.verificaTipoProduto()
            }
        },
        tipoFaturamento: {
            verificaTipoFaturamento() {
                return this.verificaTipoFaturamento()
            }
        },
        natureza: {
            verificaNatureza() {
                return this.verificaNatureza()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }

    }
}
</script>
